import styled from 'styled-components';

const PanelHeader = styled.div`
	position: fixed;
	display: flex;
	flex-direction: column;
	padding: 60px;
	padding-bottom: 0;

	> div {
		margin-bottom: 40px;

		&:nth-last-child(2) {
			margin-bottom: 20px;
		}
	}
`;

const PanelContent = styled.div`
	position: fixed;
	top: 331px;
	width: 490px;
	height: 609px;
	padding-left: 60px;
	display: flex;
	flex-direction: column;
	overflow-x: visible;
	overflow-y: scroll;

	> div:last-child {
		flex-grow: 1;
	}

	> div:not(:last-child) {
		margin-bottom: 40px;
	}

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);

		&:hover {
			background-color: rgba(255, 255, 255, 1);
		}
	}
`;

const PanelFooter = styled.div`
	position: fixed;
	left: 60px;
	bottom: 60px;
`;

export { PanelHeader, PanelContent, PanelFooter };
